import { PropsWithChildren, useState } from "react";

import { ModalContext } from "./context";
import { Backdrop, Modal, useStyles } from "./styles";

export const ModalProvider = ({ children }: PropsWithChildren) => {
  const styles = useStyles();

  const [backdropDismissable, setBackdropDismissable] = useState(true);
  const [Component, setComponent] = useState<JSX.Element | null>(null);

  const show = (NewComponent: JSX.Element, backgroundDismissable = true) => {
    setBackdropDismissable(backgroundDismissable);
    setComponent(NewComponent);
  };

  const dismiss = () => {
    setBackdropDismissable(true);
    setComponent(null);
  };

  const renderBackdrop = (props: any) => (
    <Backdrop
      {...props}
      onClick={backdropDismissable ? dismiss : undefined}
      style={styles.backdrop}
    />
  );

  return (
    <ModalContext.Provider value={{ Component, show, dismiss }}>
      {children}
      <Modal show={Component != null} renderBackdrop={renderBackdrop} style={styles.modal}>
        {Component ?? undefined}
      </Modal>
    </ModalContext.Provider>
  );
};
